import {
  Button,
  Card,
  CardBody,
  Col,
  Input,
  Label,
  Row,
  Form,
  FormGroup,
  InputGroup,
  InputGroupText,
  FormCheck,
  Container,
  Breadcrumb,
  BreadcrumbItem,
} from "reactstrap"
import { useDispatch, useSelector } from "react-redux"
import React, { useEffect, useState } from "react"
import { Link, useNavigate } from "react-router-dom"
import {
  getPvsDetails,
  verifyPvsRegistrationPayment,
} from "../../../redux/actions/pvs"
import { toast } from "react-toastify"
import { VERIFY_PVS_REGISTRATION_PAYMENT_RESET } from "../../../redux/types/pvs"
import { getUserDetailsRequest } from "../../../redux/actions/auth"

const Checkout = () => {
  const [termsAccepted, setTermsAccepted] = useState(false)
  const [couponCode, setCouponCode] = useState("")
  const [appliedCoupon, setAppliedCoupon] = useState(null)
  const { stepFormData } = useSelector(state => state.user)
  const pvsFormData = useSelector(state => state.pvs.pvsFormData)
  const user = useSelector(state => state.auth.user)
  const navigate = useNavigate()
  const dispatch = useDispatch()

  const verifyPvsRegistrationScreen = useSelector(
    state => state.screens.pvs.verifyPvsRegistrationPayment
  )

  useEffect(() => {
    if (!pvsFormData) {
      navigate("/pvs-info", { replace: true })
    }
  }, [])

  useEffect(() => {
    if (verifyPvsRegistrationScreen.success) {
      toast.success(verifyPvsRegistrationScreen.message)
      dispatch({ type: VERIFY_PVS_REGISTRATION_PAYMENT_RESET })
      navigate("/pvs-info")
    }
    if (verifyPvsRegistrationScreen.error) {
      toast.error(verifyPvsRegistrationScreen.error)
      dispatch({ type: VERIFY_PVS_REGISTRATION_PAYMENT_RESET })
    }
  }, [verifyPvsRegistrationScreen])

  const handlepayment = () => {
    const options = {
      key: process.env.REACT_APP_RZRPAY_KEY,
      amount: 1180,
      currency: "INR",
      name: "PVS Registration Payment",
      description: "PVS Registration Payment",
      order_id: pvsFormData.pay_order_id,
      // receipt: nominationOrderDetails.receipt,

      handler: async function (response) {
        // Call your backend to verify payment and update booking status
        console.log("Payment response: ", response)
        console.log(
          "Payment successful! Payment ID: ",
          response.razorpay_payment_id
        )
        let requestData = {
          razorpay_order_id: response.razorpay_order_id,
          razorpay_payment_id: response.razorpay_payment_id,
          razorpay_signature: response.razorpay_signature,
          subtotal: 1000,
          tax: 180,
          total: 1180,
          currency: "INR",
          enc_pvs_entry_id: pvsFormData.enc_pvs_entry_id,
          billing_tnc: {
            accepted: true,
            accepted_at: new Date().toLocaleString(),
            source: "web",
            userAgent: window.navigator.userAgent,
            device: window.navigator.platform,
          },
        }
        dispatch(verifyPvsRegistrationPayment(requestData))
      },
      modal: {
        ondismiss: () => {
          toast.info("Payment cancelled.")
        },
      },
      prefill: {
        email: user && user.email_id ? user.email_id : "",
      },
      theme: {
        color: "#3399cc",
      },
    }
    console.log("options:", options)

    if (window.Razorpay) {
      const rzp = new window.Razorpay(options)
      // 🔴 Card declined, 3‑DS failure, etc.
      rzp.on("payment.failed", err => {
        setPaymentLoader(false)
        console.error("Payment failed:", err.error.description)
        toast.error("❌ Payment failed. Please try again.")
      })

      // Optional: network/SDK load errors
      rzp.on("payment.error", err => {
        setPaymentLoader(false)
        toast.error("Payment could not be completed.")
      })

      rzp.open()
    } else {
      alert(
        "Payment gateway not loaded. Please refresh the page and try again."
      )
    }
  }

  return (
    <React.Fragment>
      <div className="page-content">
        {pvsFormData && (
          <Container fluid={true}>
            <div className="checkout-head-grp">
              <Button
                onClick={() => {
                  navigate(-1)
                }}
                className="disablecheckout"
              >
                <i className="dripicons-arrow-thin-left"></i>
                <span>Go Back</span>
              </Button>
            </div>

            <Row>
              {/* Left Column - Billing Details */}
              <Col lg={8} className="mb-4">
                <Card className="border-0 shadow-sm mb-4">
                  <CardBody>
                    <h5 className="pvs-checkout-title">PVS Checkout</h5>
                    <div className="border-top mb-3 pb-2"></div>
                    <div className="mb-2 d-flex align-items-center gap-1 flex-wrap">
                      <h5 className="fw-bold text-dark">
                        {pvsFormData.billing_details.company_name}
                      </h5>
                    </div>
                    <h5 className="fw-semibold mb-3">Billing Details</h5>
                    <hr className="mby-4" />
                    <div className="d-flex justify-content-between">
                      <p>Name</p>{" "}
                      <p>{pvsFormData.billing_details.company_name}</p>
                    </div>
                    <div className="d-flex justify-content-between">
                      <p>Address</p>{" "}
                      <p>{`${pvsFormData.billing_details.address}, ${pvsFormData.billing_details.city}, ${pvsFormData.billing_details.state}, Pincode: ${pvsFormData.billing_details.pincode}`}</p>
                    </div>
                    <div className="d-flex justify-content-between">
                      <p>Email</p> <p>{pvsFormData.billing_details.email_id}</p>
                    </div>
                    <div className="d-flex justify-content-between">
                      <p>Contact No. (WhatsApp)</p>{" "}
                      <p>
                        {pvsFormData.billing_details.mobile_no ||
                          "Not Provided"}
                      </p>
                    </div>
                    <div className="d-flex justify-content-between">
                      <p>GST Number</p>{" "}
                      <p>
                        {pvsFormData.billing_details.gst_number ||
                          "Not Provided"}
                      </p>
                    </div>
                  </CardBody>
                </Card>
              </Col>

              {/* Right Column - Order Summary */}
              <Col lg={4}>
                <Card className="border-0 shadow-sm">
                  <CardBody>
                    <h5 className="text-uppercase mb-4">
                      PVS Membership
                    </h5>

                    <div className="mb-4">
                      {/* <div className="d-flex justify-content-between align-items-center mb-3">
                        <div className="position-relative w-100">
                          <Input
                            type="text"
                            placeholder="Coupon Code"
                            value={couponCode}
                            onChange={e => setCouponCode(e.target.value)}
                            className="py-2"
                          />
                          <Button
                            color="primary"
                            className="position-absolute end-0 top-0 h-100"
                            style={{
                              borderTopLeftRadius: 0,
                              borderBottomLeftRadius: 0,
                            }}
                            onClick={() => {
                              if (appliedCoupon) {
                                setAppliedCoupon(null)
                              } else {
                                // Here you would typically validate the coupon
                                // For now, we'll just set it as applied
                                setAppliedCoupon({
                                  code: couponCode,
                                  discount: 10,
                                })
                              }
                            }}
                          >
                            {appliedCoupon ? "Remove" : "Apply"}
                          </Button>
                        </div>
                      </div> */}

                      <div className="border-top pt-3">
                        <div className="d-flex justify-content-between mb-2">
                          <span>Subtotal</span>
                          <span>₹ 1,000.00</span>
                        </div>
                        {appliedCoupon && (
                          <div className="d-flex justify-content-between mb-2">
                            <span>Discount (20%)</span>
                            <span>- ₹ 200.00</span>
                          </div>
                        )}
                        <div className="d-flex justify-content-between mb-2">
                          <span>GST (18%)</span>
                          <span>{appliedCoupon ? "₹ 144.00" : "₹ 180.00"}</span>
                        </div>
                        <div className="d-flex justify-content-between fw-bold mt-3 pt-2 border-top">
                          <span>Total</span>
                          <span>
                            {appliedCoupon ? "₹ 944.00" : "₹ 1,180.00"}
                          </span>
                        </div>
                      </div>

                      <FormGroup check className="mt-4">
                        <Input
                          type="checkbox"
                          id="terms"
                          checked={termsAccepted}
                          onChange={e => setTermsAccepted(e.target.checked)}
                          className="me-2"
                        />
                        <Label check for="terms">
                          I agree to the terms & conditions
                        </Label>
                      </FormGroup>

                      <Button
                        color="primary"
                        className="w-100 mt-3 py-2"
                        disabled={!termsAccepted}
                        // onClick={() => {
                        //   navigate("/payment-gateway")
                        // }}
                        onClick={handlepayment}
                      >
                        Pay Now
                      </Button>
                    </div>
                  </CardBody>
                </Card>
              </Col>
            </Row>
          </Container>
        )}
      </div>
    </React.Fragment>
  )
}

export default Checkout
